// Get rid of the loading icon once the PDF viewer loads.
(function () {
   let pdfembed = document.getElementById('pdfembed');
   pdfembed.onload = () => {
      pdfembed.classList.remove('loading');
   };
})();
